export interface ILabel {
  id: string
  path: string
  level: number
}

export interface ILabelSeparatedByLevel extends ILabel {
  children?: ILabelSeparatedByLevel[]
}

export interface ILabelDetailed {
  messagesTotal: number
  messagesTotalIncludingChildren: number
  labelsTotal: number
  id: string
  path: string
}

export interface IManageLabel {
  name: string
  isChild: boolean
  parent: string
}

export enum LabelProcessingTypeEnum {
  delete = 'delete',
  edit = 'edit',
  create = 'create',
}
